import { useEffect, useRef, useState } from 'react';

export const usePasteGuard = () => {
  const [searchValue, setSearchValue] = useState('');
  const [open, setOpen] = useState(false);
  const justPastedRef = useRef(false);
  const disarmOnPointerRef = useRef(null);

  const handleSearch = (nextSearchValue) => {
    // Ignore the synthetic onSearch('') antd fires right after a paste.
    if (nextSearchValue === '' && justPastedRef.current) return;
    setSearchValue(nextSearchValue);
  };

  const handleKeyDown = () => {
    justPastedRef.current = false;
  };

  const handlePaste = (e) => {
    const pastedText = e.clipboardData.getData('text');
    if (!pastedText) return;
    e.preventDefault();
    justPastedRef.current = true;
    setSearchValue(pastedText);
    setOpen(true);

    if (disarmOnPointerRef.current) {
      document.removeEventListener('mousedown', disarmOnPointerRef.current, true);
    }

    const disarmOnPointer = () => {
      justPastedRef.current = false;
      document.removeEventListener('mousedown', disarmOnPointer, true);
    };
    disarmOnPointerRef.current = disarmOnPointer;
    document.addEventListener('mousedown', disarmOnPointer, true);
  };

  useEffect(() => {
    return () => {
      if (disarmOnPointerRef.current) {
        document.removeEventListener('mousedown', disarmOnPointerRef.current, true);
      }
    };
  }, []);

  const handleDropdownVisibleChange = (nextOpen) => {
    // Ignore the synthetic close rc-select triggers internally right after a paste
    if (nextOpen === false && justPastedRef.current) return;
    setOpen(nextOpen);
  };

  const resetOnSelect = () => {
    justPastedRef.current = false;
    setSearchValue('');
    setOpen(false);
  };

  return {
    searchValue,
    open,
    handleSearch,
    handleKeyDown,
    handlePaste,
    handleDropdownVisibleChange,
    resetOnSelect
  };
};
